<div class="relative bg-white">
  <app-citizen-header></app-citizen-header>
  <div class="w-full mx-auto ">
    <div class="p-3 md:p-5 flex flex-col md:flex-row justify-start md:justify-between items-start w-11/12 mx-auto">
      <div class="w-full md:w-8/12 p-4" *ngIf="carouselItems$ | async as carousel">
        <div class="border-b border-primary-500">
          <app-portal-title-bar [title]="carousel?.title"></app-portal-title-bar>
        </div>

        <div class="mt-4 flex flex-col" data-aos="fade-left">
          <div class="grid grid-cols-5 gap-2">
            <img [src]="fileUrl+ carousel?.images[activeImageIndex]"
                 alt="" class=" col-span-4 relative  w-full rounded-md overflow-hidden">
            <div class="col-span-1 h-full flex flex-col gap-1">
              @for (n of carousel?.images; track n) {
                <img [src]="fileUrl+ n"
                     (click)="activeImageIndex=$index"
                     alt=""
                     class="w-10/12 mx-auto object-cover rounded-md cursor-pointer">
              }
            </div>
          </div>
          <div class="text-md mt-2 text-wrap flex flex-col w-11/12">
            <div class="ql-editor" [innerHTML]="carousel?.content"></div>
          </div>
        </div>
      </div>

      <div
        class="w-full flex flex-col gap-3 md:w-4/12 p-4 ">
        <div class=" rounded-md">
          <div class="flex items-center justify-between rounded-md bg-light_primary py-3 px-4 mb-1">
            <div class="text-xl text-primary-600 text-center">{{ "Habari Nyingine"|concat|translate }}</div>
          </div>

          <div class="grid grid-cols-1  gap-3 pt-2" *ngIf="topNews$| async as news">
            <ng-container *ngFor="let n of news; let i = index">
              <div class="w-full cursor-pointer bg-light_primary p-2 rounded-md"
                   routerLink="/news-view/{{n?.uniqueId}}">
                <div class="relative rounded-md overflow-hidden flex gap-2 ">
                  <img [src]="fileUrl+ n?.images[0]"
                       alt=""
                       class="w-32 object-cover">

                  <!--                <div class="w-32 object-cover">-->
                  <!--                  <app-portal-flip-carousel class="w-full" [height]="'full'"-->
                  <!--                                            [images]="n?.images">-->
                  <!--                  </app-portal-flip-carousel>-->
                  <!--                </div>-->


                  <div class="flex-grow px-3 flex flex-col gap-1 text-xs">
                    <div class="pb-2 text-md border-b border-secondary-500 ">
                      {{ n?.title | truncate:70 }}
                    </div>
                    <!--                  <div class="py-1 text-md">-->
                    <!--                    May 23, 2025-->
                    <!--                  </div>-->

                    <div class="py-1 text-md" [innerHtml]="n?.content|truncate:120">
                    </div>
                  </div>
                </div>

              </div>
            </ng-container>
          </div>

        </div>
      </div>

    </div>

  </div>
  <app-portal-footer></app-portal-footer>
</div>

